// src/utils/errorHandler/index.ts

import { store } from '@/src/store'
import { setError } from '@/src/store/slices/errorHandlingSlice'
import {
    getMessageForStatusCode,
    getMessageForEndpoint,
    ERROR_MESSAGES,
    VISA_ERRORS
} from '@/src/constants/error'
import { logError } from '@/src/utils/logError'

export const showUserFriendlyError = (userMessage: string, error: any) => {
    logError('API Error', error)

    // Instead of showing a notification, we'll show an error modal
    let errorCode = 'FRIENDLY_ERROR'

    // For network-related errors
    if (
        error.message &&
        (error.message.includes('Network Error') ||
            error.message.includes('Failed to fetch') ||
            error.message.includes('Network request failed') ||
            (error.request && !error.response))
    ) {
        errorCode = 'NETWORK_ERROR'
    }
    // For timeout errors
    else if (
        error.code === 'ECONNABORTED' ||
        (error.message && error.message.includes('timeout'))
    ) {
        errorCode = 'TIMEOUT_ERROR'
    }
    // For server response errors
    else if (error.response) {
        errorCode = `HTTP_${error.response.status}`
    }

    store.dispatch(
        setError({
            code: errorCode,
            message: userMessage || ERROR_MESSAGES.GENERIC_ERROR
        })
    )
}

export const handleApiError = (error: any, customMessage?: string) => {
    let errorCode = 'UNKNOWN_ERROR'
    let userFriendlyMessage = customMessage || ERROR_MESSAGES.GENERIC_ERROR

    // Handle network-related errors
    if (
        error.message &&
        (error.message.includes('Network Error') ||
            error.message.includes('Failed to fetch') ||
            error.message.includes('Network request failed') ||
            (error.request && !error.response))
    ) {
        errorCode = 'NETWORK_ERROR'
        userFriendlyMessage = ERROR_MESSAGES.NETWORK_ERROR
    }
    // Handle timeout errors
    else if (
        error.code === 'ECONNABORTED' ||
        (error.message && error.message.includes('timeout'))
    ) {
        errorCode = 'TIMEOUT_ERROR'
        userFriendlyMessage = ERROR_MESSAGES.TIMEOUT_ERROR
    }
    // Handle server response errors
    else if (error.response) {
        errorCode = `HTTP_${error.response.status}`

        // First try to use any message from the API
        if (error.response.data && error.response.data.message) {
            userFriendlyMessage = error.response.data.message
        } else {
            // Get endpoint-specific error message if no custom message is provided
            if (!customMessage && error.config && error.config.url) {
                userFriendlyMessage = getMessageForEndpoint(
                    error.config.url,
                    error.config.method
                )
            } else {
                // Fall back to status code based messages
                userFriendlyMessage = getMessageForStatusCode(
                    error.response.status
                )
            }
        }
    }

    // Log full error details
    logError(`${errorCode}: ${userFriendlyMessage}`, error)

    // Dispatch the error for the modal system
    store.dispatch(
        setError({
            code: errorCode,
            message: userFriendlyMessage
        })
    )
}
